import Vue from 'vue';

export default { 
    namespaced: true,
    state: {
        token: null,
    }, 
    mutations: {
    }, 
    actions: {
    }, 
    getters: {
    } 
}


// WEBPACK FOOTER //
// ./src/store/modules/authentication.js